const START_OF_LINE = ["#", "-", "*"]
const START_OF_WORD = ["*", "_"]
const NUMBERED_LIST = /^[0-9]+\./
const SPLIT_ON_LINE = /\n/ // matches line breaks
const SPLIT_ON_WORD = /\s/ // matches all line breaks and spaces
const COMBINATIONS = ["]("]

const createArrayFromString = (string, splitBy) =>
  string
    .split(splitBy)
    .map(item => item.trim())
    .filter(Boolean)

const checkLineForMarkdown = line => {
  if (line.length <= 1) return false
  if (START_OF_LINE.some(char => line.startsWith(char))) return true
  return line.match(NUMBERED_LIST)
}

const checkWordForMarkdown = word => {
  if (word.length <= 1) return false
  return START_OF_WORD.some(char => word.startsWith(char))
}

const checkTextForMarkdown = text =>
  COMBINATIONS.some(combination => text.includes(combination))

/**
 * Takes a string and returns true if it looks like Markdown.
 *
 * ```js
 * detectMarkdown("# Create every day") // true
 * detectMarkdown("Create every day") // false
 * ```
 *
 * @param {string} text
 * @returns {boolean} boolean
 */
function detectMarkdown(text) {
  if (!text) return false

  const hasMarkdownText = checkTextForMarkdown(text)
  if (hasMarkdownText) return true

  const lines = createArrayFromString(text, SPLIT_ON_LINE)
  const hasMarkdownLine = lines.some(line => checkLineForMarkdown(line))
  if (hasMarkdownLine) return true

  const words = createArrayFromString(text, SPLIT_ON_WORD)
  const hasMarkdownWord = words.some(word => checkWordForMarkdown(word))
  return hasMarkdownWord
}

/**
 * Formats a Markdown string as HTML.
 *
 * ```js
 * markdownToHTML("_italicized_")
 * // returns "<i>italicized</i>"
 * ```
 *
 * @param {string} text
 * @returns {promise} a promise which resolves to an HTML string
 */
async function markdownToHTML(text) {
  const response = await fetch("/markdown/format", {
    credentials: "include",
    method: "POST",
    body: JSON.stringify({ content: text }),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content
    }
  })
  const { content } = await response.json()
  return content
}

export { detectMarkdown, markdownToHTML }
